import { shopperApprovedWidget } from '@/scripts/shopperApproved';
import styled from 'styled-components';
import Screen from 'src/styles/Themes/Screen';

export const ShopperApproved = ({ noSearch }: { noSearch?: boolean }) => {
    return (
        <>
            <Wrapper
                href="https://www.shopperapproved.com/reviews/TripShock.com"
                className="shopperlink"
                target="_blank"
                noSearch={noSearch}
            >
                <img
                    width="178"
                    height="91"
                    src="/image/ShopperApproved.svg"
                    alt="5 Star Excellence award from Shopper Approved for collecting at least 100 5 star reviews"
                    onContextMenu={() => {
                        const d = new Date();
                        alert(
                            'Copying Prohibited by Law - This image and all included logos are copyrighted by Shopper Approved \xa9 ' +
                                d.getFullYear() +
                                '.'
                        );
                        return false;
                    }}
                />
            </Wrapper>
            <script
                id="ShopperApprovedLabel"
                type="text/javascript"
                dangerouslySetInnerHTML={{
                    __html: shopperApprovedWidget,
                }}
            />
        </>
    );
};

const Wrapper = styled.a<{ noSearch?: boolean }>`
    position: absolute;
    background-color: rgba(34, 47, 60, 0.7);
    border-radius: 100px;
    top: ${({ noSearch }) => (noSearch ? '-4px' : '4px')};
    right: -34px;
    padding: 6px 20px 0 8px;

    ${Screen.ipad} {
        top: 4px;
        right: -50px;
        padding: 6px 24px 0 12px;
    }

    ${Screen.desktop} {
        top: auto;
        right: auto;
        bottom: -140px;
        left: calc(50% - 139px);
        padding: 14px 50px 6px;
        background-color: transparent;
    }

    img {
        height: 36px;
        width: 70px;

        ${Screen.ipad} {
            height: 50px;
            width: 98px;
        }

        ${Screen.desktop} {
            height: auto;
            width: 178px;
        }
    }
`;
